<template>
  <div>
    <div class="stepper panel panel-body">
      <general-stepper
        :steps-info="stepsInfo"
        :enable-save-button="enableSaveButton"
        @finish="saveSubscribable"
        @changeStep="changeStep"
      >
        <!--contents step-->
        <template
          slot="content-step-1"
          class="col-xs-12"
        >
          <select-exam
            @canFinishStep="finishStep(1)"
            @canNotFinishStep="notFinishStep(1)"
          />
        </template>

        <template
          slot="content-step-2"
          class="col-xs-12"
        >
          <subscribable
            :errors="errors"
            :deadline_time="sub_deadline_time"
            :start_time="sub_start_time"
            :can_subscribe_group_members="can_subscribe_group_members"
            @canFinishStep="finishStep(2)"
            @canNotFinishStep="notFinishStep(2)"
          />
        </template>
      </general-stepper>
    </div>
    <div class="panel panel-body">
      <exam-info />
    </div>
  </div>
</template>

<script>

import SelectExam from './SelectExam'
import Subscribable from './Subscribable'
import ExamInfo from './ExamInfo'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'ExamSubscribablesSteps',
  components: { SelectExam, ExamInfo, Subscribable },
  props: {
    sub_start_time: {
      required: false,
      default: '12:00:00',
    },
    sub_deadline_time: {
      required: false,
      default: '23:59:59',
    },
    can_subscribe_group_members: {
      required: false,
      default: 0,
      type: Number,
    },

  },

  data () {
    return {
      errors: null,
      enableSaveButton: false,
    }
  },

  computed: {
    stepsInfo () {
      return this.$store.state.steps.steps_info
    },
  },

  created () {
    let stepsInfo = {
      1: {
        step: 1,
        title: Lang.get('core.select_object', { object: Lang.get('core.exam') }),
        finished: false,
      },
      2: {
        step: 2,
        title: Lang.get('subscription.eventseries.parameters'),
        finished: false,
      },
    }
    this.$store.dispatch('add_steps_info', stepsInfo)
    this.$store.dispatch('set_active_step', { step: stepsInfo[1] })
  },

  methods: {
    changeStep (event) {
      this.$store.dispatch('set_active_step', { step: event.step })
    },

    finishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: true })
    },

    notFinishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: false })
    },

    saveSubscribable () {
      this.errors = null

      const subscribable = this.$store.state.exams.subscribable
      const data = {
        exam_name: this.$store.state.exams.exam_name,
        exam_date: this.$store.state.exams.exam_date,
        classroom_capacities: this.$store.state.exams.capacities,
        classroom_order: this.$store.state.exams.order,
        name: subscribable.name,
        description: subscribable.description,
        sub_start_time: subscribable.sub_start_time,
        sub_deadline_time: subscribable.sub_deadline_time,
        sub_unsubscription_deadline_time: subscribable.sub_unsubscription_deadline_time,
        with_unsubscription: subscribable.with_unsubscription,
        with_minimum_subscriptions: subscribable.with_minimum_subscriptions,
        minimum_subscriptions: subscribable.minimum_subscriptions,
        startdate: subscribable.startdate,
        deadline: subscribable.deadline,
        unsubscription_deadline: subscribable.unsubscription_deadline,
        subscribable_groups: subscribable.subscribable_groups,
        student_can_subscribe_group_members: subscribable.student_can_subscribe_group_members,
        questions: subscribable.questions,
        with_queue: subscribable.with_queue,
        ...subscribable.questions_order,
      }

      axios.post(`/exam/subscribables`, data, { errorHandle: false }).then(data => {
        window.location.href = data.data.redirect
      }).catch(error => {
        this.errors = {}
        Object.keys(error.response.data).forEach(key => {
          this.errors[key] = error.response.data[key]
        })

        this.enableSaveButton = !this.enableSaveButton

        defaultErrorMessage(error)
      })
    },
  },
}
</script>

<style lang="scss">
    .stepper {
        .v-stepper {
            margin-bottom: 15px;
        }

        .label {
            background: none;
        }
    }
</style>
